<template>
  <v-sheet height="64">
    <v-toolbar flat color="white">
      <v-btn outlined class="mr-4" color="grey darken-2" @click="$emit('setToday')">
        Today
      </v-btn>
      <v-btn fab text small color="grey darken-2" @click="$emit('prev')">
        <v-icon small>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn fab text small color="grey darken-2" @click="$emit('next')">
        <v-icon small>mdi-chevron-right</v-icon>
      </v-btn>
      <v-toolbar-title v-if="$refs.calendar">
        {{ $refs.calendar.title }}
      </v-toolbar-title>
      <v-spacer />
      <v-menu
        bottom right >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            outlined
            color="grey darken-2"
            v-bind="attrs"
            v-on="on"
          >
            <span>{{ typeToLabel[type] }}</span>
            <v-icon right>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="type = 'day'; $emit('changeType', 'day')">
            <v-list-item-title>Day</v-list-item-title>
          </v-list-item>
          <v-list-item @click="type = 'week'; $emit('changeType', 'week')">
            <v-list-item-title>Week</v-list-item-title>
          </v-list-item>
          <v-list-item @click="type = 'month'; $emit('changeType', 'month')">
            <v-list-item-title>Month</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>
  </v-sheet>
</template>

<script>
export default {
  name: 'CalendarHeader',
  data: () => ({
    typeToLabel: {
      month: 'Month',
      week: 'Week',
      day: 'Day'
    },
    type: 'day'
  })
}
</script>

<style lang="sass" scoped>

</style>
